import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconExcelsior from '../build/icon-excelsior'

export const IconExcelsior: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconExcelsior} />
}

export default IconExcelsior
